














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) editData!: any; // 传递给编辑页面-数据对象
  // 表单数据
  formData: any = {};

  formRules: any = {};

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取隐患详情数据
    this.getDataById();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDataById() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getDutyRuleListDetail(this.editData.id)
      .then((res: any) => {
        this.formData = res.data;
        if (res.data.executeStaffId) {
          this.formData.name = res.data.executeStaffName;
        }
        if (res.data.executeDepartmentId && !res.data.executeStaffId) {
          this.formData.name = res.data.executeDepartmentName;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('refreshData');
  }
}
